import LoginBox from "./LoginBox"
import TrackingBox from "./TrackingBox"

const AboutUs = () => {
  return (
    <>
      <section>
        <div className="container-fluid">
          <img src="images/innerbanner.webp" className='img-fluid' alt="" />
        </div>
      </section>

      {/* MAIN SECTION */}
      <section className="main-section">
        <div className="container">
          <div className="row g-4">

            {/* SIDEBAR */}
            <div className="col-lg-3">

              <TrackingBox />
              <LoginBox />

              {/* Contact */}
              <div className="contact-card">
                <div className="contact-title">Contact</div>

                <div className="contact-item">
                  <div className="contact-icon phone">
                    <i className="fa fa-phone"></i>
                  </div>
                  <a href="tel:01141606842">+91 96672 33072</a>
                </div>

                <div className="contact-item">
                  <div className="contact-icon email">
                    <i className="fa fa-envelope"></i>
                  </div>
                  <a href="#">oxford_express@yahoo.co.in</a>
                </div>

                <div className="contact-item">
                  <div className="contact-icon email">
                    <i className="fa fa-envelope"></i>
                  </div>
                  <a href="#">info@oxfordexp.com</a>
                </div>
              </div>
            </div>

            {/* CONTENT */}
            <div className="col-lg-9">

              {/* Welcome */}
              <div className="bg-white rounded-3 p-4 mb-4 shadow-sm">

                <h2 className="section-title">
                  ABOUT US
                </h2>

                <p className="welcome-text">
                  Oxford Express Private Limited was incorporated with the main objective of providing premium logistic services to the client demanding quality services. Company is governed by Mr. Mukesh Mittal (Director of the company).
                </p>
              </div>

              {/* Services + News */}
              <div className="row g-4">

                {/* Services */}
                <div className="col-md-12">
                  <div className="services-box">
                    <div className="services-box-header">People<span></span></div>

                    <div className="p-3">
                      <p className="welcome-text">Oxford Express recognises that our people, at every level of the company, are our greatest asset. It is their knowledge and expertise which ensures that the rest of the assets - from vehicles to state of the art warehouse management systems - provide the optimum logistics solution for each of our customers. Our people work as an integral part of our customer's teams. They feel as much loyalty to the customer's company as they do to their own. They work on the customer's premises;</p>

                      <p className="welcome-text">The company has a team of qualified and trained staff with adequate courier Knowledge and experience to cater the ever-increasing demands of the corporate sector. Our operations are controlled from our New Delhi Regd. Office. well-trained staff & latest electronic systems to handle on an average 4.5 lakhs of packet per month.</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="services-box">
                    <div className="services-box-header">Mission<span></span></div>

                    <div className="p-3">
                      <p className="welcome-text">Our mission is to exceed customers' expectations in the transfer of their goods and documents around the world. We deliver value to our customers by providing the most reliable and efficient solutions in distribution and logistics. We lead the industry by instilling pride in our people, creating value for our stakeholders and sharing responsibility for our world.</p>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="services-box">
                    <div className="services-box-header">Vision<span></span></div>

                    <div className="p-3">
                      <p className="welcome-text">The essence of what we strive for: 'Delivering more' : Our vision strongly reflects who we are: ambitious, optimistic, result-oriented. It communicates our confidence that we can always overcome obstacles and achieve our goals. It is that special mark that allows us to stand out from the crowd</p>
                    </div>
                  </div>
                </div>


                <div className="col-md-12">
                  <div className="services-box">
                    <div className="services-box-header">Our Standards<span></span></div>

                    <div className="p-3">
                    <ul className="services-list">
                          <li>Aim to satisfy customers every time.</li>
                          <li>Challenge and improve all we do.</li>
                          <li>Be passionate about our people.</li>
                          <li>Act as a team.</li>
                        </ul>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* STATS STRIP */}
      <section className="stats-strip">
        <div className="container">
          <div className="row g-0 text-center">

            <div className="col-6 col-md-3 stat-item py-2">
              <div className="stat-number">4.5L+</div>
              <div className="stat-label">Packets / Month</div>
            </div>

            <div className="col-6 col-md-3 stat-item py-2">
              <div className="stat-number">1000+</div>
              <div className="stat-label">Cities Covered</div>
            </div>

            <div className="col-6 col-md-3 stat-item py-2">
              <div className="stat-number">35+</div>
              <div className="stat-label">Years Experience</div>
            </div>

            <div className="col-6 col-md-3 stat-item py-2">
              <div className="stat-number">10K+</div>
              <div className="stat-label">Happy Clients</div>
            </div>

          </div>
        </div>
      </section>
    </>
  )
}

export default AboutUs